// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__sxjEB","title":"Info_title__1f0Rl","selects":"Info_selects__3i2mM","requiredAsterisk":"Info_requiredAsterisk__9a4Wt"};